// ============================================
// 📋 CATÁLOGO DE EXAMES COM CÓDIGOS TUSS
// ============================================

export interface ExameTUSS {
  nome: string;
  tuss: string;
  categoria: "laboratorial" | "imagem" | "outro";
}

// Catálogo geral de exames disponíveis
export const catalogoExames: ExameTUSS[] = [
  // BIOQUÍMICA
  { nome: "Albumina sérica", tuss: "40301222", categoria: "laboratorial" },
  {
    nome: "Alfa-fetoproteína sérica",
    tuss: "40316068",
    categoria: "laboratorial",
  },
  { nome: "ALT (TGP)", tuss: "40302512", categoria: "laboratorial" },
  { nome: "Amilase sérica", tuss: "40301281", categoria: "laboratorial" },
  { nome: "AST (TGO)", tuss: "40302504", categoria: "laboratorial" },
  {
    nome: "Bilirrubina total e frações séricas",
    tuss: "40301397",
    categoria: "laboratorial",
  },
  { nome: "Cálcio sérico", tuss: "40301400", categoria: "laboratorial" },
  {
    nome: "Colesterol total e frações",
    tuss: "40302750",
    categoria: "laboratorial",
  },
  { nome: "Creatinina sérica", tuss: "40301630", categoria: "laboratorial" },
  {
    nome: "Eletroforese de proteínas séricas",
    tuss: "40301761",
    categoria: "laboratorial",
  },
  { nome: "Ferritina", tuss: "40316270", categoria: "laboratorial" },
  {
    nome: "Fosfatase alcalina sérica",
    tuss: "40301885",
    categoria: "laboratorial",
  },
  { nome: "Fósforo sérico", tuss: "40301931", categoria: "laboratorial" },
  { nome: "Gama GT", tuss: "40301990", categoria: "laboratorial" },
  { nome: "Glicemia em jejum", tuss: "40302040", categoria: "laboratorial" },
  {
    nome: "Grupo sanguíneo ABO e RH",
    tuss: "40403173",
    categoria: "laboratorial",
  },
  {
    nome: "Hemoglobina glicada A1C",
    tuss: "40302733",
    categoria: "laboratorial",
  },
  {
    nome: "Frutosaminas (proteínas glicosiladas) - pesquisa e/ou dosagem",
    tuss: "40301958",
    categoria: "laboratorial",
  },
  { nome: "Lipase sérica", tuss: "40302199", categoria: "laboratorial" },
  {
    nome: "Peptídeo C - pesquisa e/ou dosagem",
    tuss: "40316394",
    categoria: "laboratorial",
  },
  { nome: "Magnésio sérico", tuss: "40302237", categoria: "laboratorial" },
  { nome: "Potássio sérico", tuss: "40302318", categoria: "laboratorial" },
  {
    nome: "Proteínas totais e frações",
    tuss: "40302385",
    categoria: "laboratorial",
  },
  {
    nome: "Saturação de transferrina",
    tuss: "40321231",
    categoria: "laboratorial",
  },
  {
    nome: "Capacidade de fixação de ferro - pesquisa e/ou dosagem",
    tuss: "40301427",
    categoria: "laboratorial",
  },
  {
    nome: "Ferro sérico - pesquisa e/ou dosagem",
    tuss: "40301842",
    categoria: "laboratorial",
  },
  { nome: "Sódio sérico", tuss: "40302423", categoria: "laboratorial" },
  { nome: "Triglicerídeos", tuss: "40302547", categoria: "laboratorial" },
  { nome: "Ureia sérica", tuss: "40302580", categoria: "laboratorial" },
  { nome: "Ácido úrico sérico", tuss: "40301150", categoria: "laboratorial" },

  // HEMATOLOGIA
  { nome: "Hemograma completo", tuss: "40304361", categoria: "laboratorial" },
  { nome: "Tempo de protrombina", tuss: "40304590", categoria: "laboratorial" },
  { nome: "TTPA", tuss: "40304639", categoria: "laboratorial" },
  { nome: "Fibrinogênio", tuss: "40304264", categoria: "laboratorial" },

  // IMUNOSSUPRESSORES
  { nome: "Tacrolimo sérico", tuss: "40302458", categoria: "laboratorial" },
  { nome: "Everolimo sérico", tuss: "40322319", categoria: "laboratorial" },
  { nome: "Sirolimo sérico", tuss: "40321568", categoria: "laboratorial" },
  { nome: "Ciclosporina sérica", tuss: "40301486", categoria: "laboratorial" },
  { nome: "Micofenolato sérico", tuss: "40302881", categoria: "laboratorial" },

  // SOROLOGIAS
  { nome: "Anti-HCV", tuss: "40307026", categoria: "laboratorial" },
  { nome: "Anti-HBs", tuss: "40306992", categoria: "laboratorial" },
  { nome: "HBsAg", tuss: "40307018", categoria: "laboratorial" },
  { nome: "Anti-HBc IgG", tuss: "40306950", categoria: "laboratorial" },
  { nome: "Anti-HBc IgM", tuss: "40306968", categoria: "laboratorial" },
  { nome: "HBeAg", tuss: "40306984", categoria: "laboratorial" },
  { nome: "Anti-HBe", tuss: "40306976", categoria: "laboratorial" },
  { nome: "Anti-HAV IgG", tuss: "40306933", categoria: "laboratorial" },
  { nome: "Anti-HAV IgM", tuss: "40306941", categoria: "laboratorial" },
  { nome: "Anti-HIV 1 e 2", tuss: "40307182", categoria: "laboratorial" },
  { nome: "VDRL", tuss: "40307760", categoria: "laboratorial" },
  {
    nome: "Sífilis - FTA-ABS-IgG - pesquisa",
    tuss: "40307735",
    categoria: "laboratorial",
  },
  {
    nome: "Sífilis - FTA-ABS-IgM - pesquisa",
    tuss: "40307743",
    categoria: "laboratorial",
  },
  { nome: "Anti-CMV IgG", tuss: "40306666", categoria: "laboratorial" },
  { nome: "Anti-CMV IgM", tuss: "40306674", categoria: "laboratorial" },
  { nome: "Anti-EBV IgG (VCA)", tuss: "40307573", categoria: "laboratorial" },
  { nome: "Anti-EBV IgM (VCA)", tuss: "40307581", categoria: "laboratorial" },
  {
    nome: "Anti-toxoplasmose IgG",
    tuss: "40307824",
    categoria: "laboratorial",
  },
  {
    nome: "Anti-toxoplasmose IgM",
    tuss: "40307832",
    categoria: "laboratorial",
  },
  { nome: "Chagas (sorologia)", tuss: "40306615", categoria: "laboratorial" },
  { nome: "HTLV I/II", tuss: "40307212", categoria: "laboratorial" },
  {
    nome: "Estrongiloidíase (anticorpos anti-Strongyloides)",
    tuss: "40308839",
    categoria: "laboratorial",
  },
  {
    nome: "Esquistossomose - IgG - pesquisa e/ou dosagem",
    tuss: "40307719",
    categoria: "laboratorial",
  },
  {
    nome: "Esquistossomose - IgM - pesquisa e/ou dosagem",
    tuss: "40307727",
    categoria: "laboratorial",
  },
  {
    nome: "Rubéola - IgG - pesquisa e/ou dosagem",
    tuss: "40307697",
    categoria: "laboratorial",
  },
  {
    nome: "Rubéola - IgM - pesquisa e/ou dosagem",
    tuss: "40307700",
    categoria: "laboratorial",
  },
  {
    nome: "Anti-HDV (hepatite delta) - IGG",
    tuss: "40307050",
    categoria: "laboratorial",
  },
  {
    nome: "Anti-HDV (hepatite delta) - IGM",
    tuss: "40307069",
    categoria: "laboratorial",
  },
  {
    nome: "Hepatite delta, antígeno - pesquisa e/ou dosagem",
    tuss: "40307077",
    categoria: "laboratorial",
  },
  { nome: "CMV PCR quantitativo", tuss: "40314030", categoria: "laboratorial" },
  { nome: "EBV PCR quantitativo", tuss: "40314359", categoria: "laboratorial" },
  { nome: "PPD (tuberculina)", tuss: "40307638", categoria: "laboratorial" },
  {
    nome: "IGRA / Quantiferon-TB (interferon-gama)",
    tuss: "40324648",
    categoria: "laboratorial",
  },
  {
    nome: "HCV-RNA (PCR quantitativo)",
    tuss: "40314103",
    categoria: "laboratorial",
  },
  {
    nome: "HBV-DNA (PCR quantitativo)",
    tuss: "40314081",
    categoria: "laboratorial",
  },
  {
    // HDV-RNA carga viral: ⚠️ a Tabela 22 TUSS NÃO possui código para a carga viral
    // do Delta (só antígeno 40307077 e anticorpos 40307050/40307069). O código abaixo
    // (40399039) é um PLACEHOLDER INTERNO — não é TUSS oficial e não deve faturar convênio
    // (auditoria B282/AI_122, OK de Leonardo: "manter com aviso"). Ele permanece porque
    // também é a chave que dispara o Formulário de Carga Viral Delta do SUS (gatilho cv-hdv).
    nome: "HDV-RNA (carga viral, Hepatite Delta)",
    tuss: "40399039",
    categoria: "laboratorial",
  },
  {
    // HIV — carga viral por PCR (quantitativo). Exame do catálogo; não dispara
    // o formulário de DNA pró-viral (que é qualitativo). Código de Leonardo (AI_96).
    nome: "HIV - carga viral PCR - pesquisa",
    tuss: "40314120",
    categoria: "laboratorial",
  },
  {
    // HIV — qualitativo por PCR. DISPARA o formulário de Detecção do DNA
    // pró-viral do HIV-1 (qualitativo). Código informado por Leonardo (AI_96).
    nome: "HIV - qualitativo por PCR - pesquisa",
    tuss: "40314138",
    categoria: "laboratorial",
  },
  {
    // Genotipagem do VHC — DISPARA o formulário de Genotipagem do Vírus da
    // Hepatite C (gov.br/aids). Código informado por Leonardo (AI_96).
    nome: "Hepatite C - genotipagem - pesquisa",
    tuss: "40314111",
    categoria: "laboratorial",
  },

  // AUTOANTICORPOS
  {
    nome: "FAN (fator anti-nuclear)",
    tuss: "40306852",
    categoria: "laboratorial",
  },
  { nome: "Anti-LKM-1", tuss: "40306097", categoria: "laboratorial" },
  {
    nome: "Anticorpos anti-músculo liso",
    tuss: "40306399",
    categoria: "laboratorial",
  },
  {
    nome: "Anticorpo anti-mitocôndria",
    tuss: "40306356",
    categoria: "laboratorial",
  },
  // ANCA (B282/AI_122): a TUSS separa em dois padrões; o item genérico virou dois.
  {
    nome: "ANCA - padrão perinuclear (p-ANCA)",
    tuss: "40306410",
    categoria: "laboratorial",
  },
  {
    nome: "ANCA - padrão citoplasmático (c-ANCA)",
    tuss: "40306402",
    categoria: "laboratorial",
  },
  { nome: "Anti-DNA nativo", tuss: "40306062", categoria: "laboratorial" },

  // MARCADORES TUMORAIS
  { nome: "CA 19-9", tuss: "40316378", categoria: "laboratorial" },
  { nome: "CEA", tuss: "40316122", categoria: "laboratorial" },
  { nome: "CA 125", tuss: "40316378", categoria: "laboratorial" },
  { nome: "PSA total", tuss: "40316149", categoria: "laboratorial" },

  // HORMÔNIOS / OUTROS
  { nome: "TSH", tuss: "40316521", categoria: "laboratorial" },
  { nome: "T4 livre", tuss: "40316491", categoria: "laboratorial" },
  { nome: "T3 livre", tuss: "40316467", categoria: "laboratorial" },
  { nome: "Vitamina D (25-OH)", tuss: "40302830", categoria: "laboratorial" },
  { nome: "Vitamina B12", tuss: "40316572", categoria: "laboratorial" },
  { nome: "Ácido fólico", tuss: "40301087", categoria: "laboratorial" },
  { nome: "Paratormônio (PTH)", tuss: "40305465", categoria: "laboratorial" },

  // URINA
  { nome: "Urina tipo I (EAS)", tuss: "40311210", categoria: "laboratorial" },
  {
    nome: "Urocultura, com contagem de colônias",
    tuss: "40310213",
    categoria: "laboratorial",
  },
  {
    nome: "Proteinúria de 24 horas",
    tuss: "40302377",
    categoria: "laboratorial",
  },
  { nome: "Microalbuminúria", tuss: "40311171", categoria: "laboratorial" },
  // B281 (AI_120) — creatinina e sódio em urina (amostra/12h/24h). TUSS conforme
  // a tabela de Leonardo: creatinina urinária = 40301630, sódio urinário =
  // 40302423 (mesmos códigos dos analitos no soro; o material é especificado no
  // pedido). A creatinina urinária de 24h existente foi alinhada de 40311066 →
  // 40301630 (decisão de Leonardo, p/ ficar consistente com a de 12h).
  {
    nome: "Creatinina urinária (12 horas)",
    tuss: "40301630",
    categoria: "laboratorial",
  },
  {
    nome: "Creatinina urinária (24 horas)",
    tuss: "40301630",
    categoria: "laboratorial",
  },
  {
    nome: "Clearance de creatinina (24 horas)",
    tuss: "40301508",
    categoria: "laboratorial",
  },
  {
    nome: "Sódio urinário (amostra isolada)",
    tuss: "40302423",
    categoria: "laboratorial",
  },
  {
    nome: "Sódio urinário (12 horas)",
    tuss: "40302423",
    categoria: "laboratorial",
  },
  {
    nome: "Sódio urinário (24 horas)",
    tuss: "40302423",
    categoria: "laboratorial",
  },
  {
    nome: "Índice de proteína/creatinina urinário",
    tuss: "40322483",
    categoria: "laboratorial",
  },

  // BIOQUÍMICA — COMPLEMENTAR
  {
    nome: "Ácido láctico (lactato)",
    tuss: "40301109",
    categoria: "laboratorial",
  },
  { nome: "Amônia sérica", tuss: "40301320", categoria: "laboratorial" },
  { nome: "Alfa-1-antitripsina", tuss: "40301249", categoria: "laboratorial" },
  { nome: "Cálcio iônico", tuss: "40301419", categoria: "laboratorial" },
  { nome: "Ceruloplasmina", tuss: "40301478", categoria: "laboratorial" },
  { nome: "Cloro sérico", tuss: "40301559", categoria: "laboratorial" },
  { nome: "Cobre sérico", tuss: "40301567", categoria: "laboratorial" },
  {
    nome: "Creatino fosfoquinase total (CK)",
    tuss: "40301648",
    categoria: "laboratorial",
  },
  { nome: "CK-MB massa", tuss: "40301656", categoria: "laboratorial" },
  {
    nome: "Desidrogenase láctica (LDH)",
    tuss: "40301729",
    categoria: "laboratorial",
  },
  {
    nome: "Gasometria (pH, pCO2, SA, O2, excesso base) - pesquisa e/ou dosagem",
    tuss: "40302016",
    categoria: "laboratorial",
  },
  {
    nome: "Gasometria + Hb + Ht + Na +  K + Cl + Ca + glicose + lactato (quando efetuado no gasômetro) - pesquisa e/ou dosagem",
    tuss: "40302024",
    categoria: "laboratorial",
  },
  { nome: "Haptoglobina", tuss: "40302067", categoria: "laboratorial" },
  { nome: "Procalcitonina", tuss: "40302687", categoria: "laboratorial" },
  {
    nome: "Proteína C reativa quantitativa",
    tuss: "40308391",
    categoria: "laboratorial",
  },
  { nome: "Troponina", tuss: "40302571", categoria: "laboratorial" },
  { nome: "BNP/Pro-BNP", tuss: "40302776", categoria: "laboratorial" },
  { nome: "Zinco sérico", tuss: "40313328", categoria: "laboratorial" },
  { nome: "Vitamina B1", tuss: "40302784", categoria: "laboratorial" },
  { nome: "Vitamina B6", tuss: "40302814", categoria: "laboratorial" },
  { nome: "Vitamina K", tuss: "40302849", categoria: "laboratorial" },

  // HEMATOLOGIA — COMPLEMENTAR
  {
    nome: "VHS (hemossedimentação)",
    tuss: "40304370",
    categoria: "laboratorial",
  },
  { nome: "Reticulócitos", tuss: "40304558", categoria: "laboratorial" },
  { nome: "Coombs direto", tuss: "40304108", categoria: "laboratorial" },
  { nome: "Coombs indireto", tuss: "40304884", categoria: "laboratorial" },
  {
    nome: "Coagulograma completo",
    tuss: "40304922",
    categoria: "laboratorial",
  },
  { nome: "Dímero D", tuss: "40304906", categoria: "laboratorial" },
  { nome: "Antitrombina III", tuss: "40304060", categoria: "laboratorial" },
  {
    nome: "Proteína C da coagulação",
    tuss: "40304507",
    categoria: "laboratorial",
  },
  { nome: "Proteína S livre", tuss: "40304787", categoria: "laboratorial" },

  // IMUNOLOGIA
  { nome: "IgA sérica", tuss: "40307220", categoria: "laboratorial" },
  { nome: "IgG sérica", tuss: "40307280", categoria: "laboratorial" },
  { nome: "IgM sérica", tuss: "40307301", categoria: "laboratorial" },
  { nome: "Complemento C3", tuss: "40306704", categoria: "laboratorial" },
  { nome: "Complemento C4", tuss: "40306712", categoria: "laboratorial" },

  // EXAMES DE IMAGEM — ULTRASSONOGRAFIA
  {
    nome: "Ultrassonografia de abdome superior",
    tuss: "40901130",
    categoria: "imagem",
  },
  { nome: "Ecoendoscopia alta", tuss: "40201104", categoria: "imagem" },
  { nome: "Ecoendoscopia baixa", tuss: "40201112", categoria: "imagem" },
  {
    nome: "Ultrassonografia de abdome total",
    tuss: "40901122",
    categoria: "imagem",
  },
  {
    nome: "Ultrassonografia de abdome inferior feminino",
    tuss: "40901181",
    categoria: "imagem",
  },
  {
    nome: "Ultrassonografia de abdome inferior masculino",
    tuss: "40901173",
    categoria: "imagem",
  },
  { nome: "Ultrassonografia de mamas", tuss: "40901114", categoria: "imagem" },
  {
    nome: "Ultrassonografia de tireoide",
    tuss: "40901203",
    categoria: "imagem",
  },
  {
    nome: "Ultrassonografia de parede abdominal",
    tuss: "40901211",
    categoria: "imagem",
  },
  {
    nome: "Ultrassonografia transvaginal",
    tuss: "40901300",
    categoria: "imagem",
  },
  {
    nome: "Ultrassonografia de próstata transretal",
    tuss: "40901335",
    categoria: "imagem",
  },
  {
    nome: "Punção biópsia/aspirativa de órgão ou estrutura superficial orientada por US (não inclui o exame de base)",
    tuss: "40809161",
    categoria: "imagem",
  },
  {
    nome: "Biópsia hepática transparietal (até 3 fragmentos)",
    tuss: "31005071",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — DOPPLER
  {
    nome: "Doppler colorido de órgão ou estrutura isolada (fígado)",
    tuss: "40901386",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido de aorta e artérias renais",
    tuss: "40901394",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido de aorta e ilíacas",
    tuss: "40901408",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido de artérias viscerais (mesentéricas e tronco celíaco)",
    tuss: "40901416",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido de veia cava superior ou inferior",
    tuss: "40901432",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido de vasos cervicais arteriais bilateral",
    tuss: "40901360",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido arterial de membro inferior - unilateral",
    tuss: "40901475",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido venoso de membro inferior - unilateral",
    tuss: "40901483",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido arterial de membro superior - unilateral",
    tuss: "40901459",
    categoria: "imagem",
  },
  {
    nome: "Doppler colorido venoso de membro superior - unilateral",
    tuss: "40901467",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — ECOCARDIOGRAMA E CARDIO
  {
    nome: "Ecocardiograma transtorácico com Doppler",
    tuss: "40901106",
    categoria: "imagem",
  },
  {
    nome: "Ecocardiograma transesofágico",
    tuss: "40901092",
    categoria: "imagem",
  },
  {
    nome: "Ecocardiograma com estresse farmacológico",
    tuss: "40901076",
    categoria: "imagem",
  },
  {
    nome: "ECG convencional de até 12 derivações",
    tuss: "40101010",
    categoria: "imagem",
  },
  {
    nome: "Holter de 24 horas - 2 ou mais canais - analógico",
    tuss: "20102011",
    categoria: "imagem",
  },
  {
    nome: "Holter de 24 horas - 3 canais - digital",
    tuss: "20102020",
    categoria: "imagem",
  },
  {
    nome: "Teste ergométrico computadorizado (inclui ECG basal convencional)",
    tuss: "40101037",
    categoria: "imagem",
  },
  {
    nome: "Teste ergométrico convencional - 3 ou mais derivações simultâneas (inclui ECG basal convencional)",
    tuss: "40101045",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — TOMOGRAFIA
  { nome: "TC de crânio", tuss: "41001010", categoria: "imagem" },
  { nome: "TC de tórax", tuss: "41001079", categoria: "imagem" },
  { nome: "TC de abdome superior", tuss: "41001109", categoria: "imagem" },
  { nome: "TC de abdome total", tuss: "41001095", categoria: "imagem" },
  { nome: "TC de pelve", tuss: "41001117", categoria: "imagem" },
  {
    nome: "Angiotomografia de aorta abdominal",
    tuss: "41001184",
    categoria: "imagem",
  },
  {
    nome: "Angiotomografia de aorta torácica",
    tuss: "41001176",
    categoria: "imagem",
  },
  {
    nome: "Angiotomografia arterial de abdome superior",
    tuss: "41001435",
    categoria: "imagem",
  },
  {
    nome: "Angiotomografia venosa de abdome superior",
    tuss: "41001443",
    categoria: "imagem",
  },
  {
    nome: "Angiotomografia arterial de pelve",
    tuss: "41001451",
    categoria: "imagem",
  },
  {
    nome: "Angiotomografia arterial pulmonar",
    tuss: "41001516",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — RESSONÂNCIA MAGNÉTICA
  {
    nome: "RM de abdome superior (fígado, pâncreas, baço, rins)",
    tuss: "41101170",
    categoria: "imagem",
  },
  {
    nome: "Colangioressonância",
    tuss: "41101359",
    categoria: "imagem",
  },
  { nome: "RM de pelve", tuss: "41101189", categoria: "imagem" },
  { nome: "RM de crânio (encéfalo)", tuss: "41101014", categoria: "imagem" },
  { nome: "RM de tórax", tuss: "41101120", categoria: "imagem" },
  {
    nome: "RM - Avaliação de ferro hepático",
    tuss: "41101430",
    categoria: "imagem",
  },
  {
    nome: "Angio-RM de aorta abdominal",
    tuss: "41101340",
    categoria: "imagem",
  },
  {
    nome: "Angio-RM arterial de abdome superior",
    tuss: "41101510",
    categoria: "imagem",
  },
  {
    nome: "Angio-RM venosa de abdome superior",
    tuss: "41101529",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — ELASTOGRAFIA
  {
    nome: "Elastografia hepática ultrassônica (FibroScan)",
    tuss: "40901793",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — ENDOSCOPIA
  { nome: "Endoscopia digestiva alta", tuss: "40201120", categoria: "imagem" },
  {
    nome: "Endoscopia digestiva alta com biópsia",
    tuss: "40202038",
    categoria: "imagem",
  },
  {
    nome: "Endoscopia digestiva alta com biópsia e teste de urease (pesquisa Helicobacter pylori)",
    tuss: "40202615",
    categoria: "imagem",
  },
  { nome: "Colonoscopia", tuss: "40201082", categoria: "imagem" },
  {
    nome: "Colangiopancreatografia retrógrada endoscópica",
    tuss: "40201074",
    categoria: "imagem",
  },
  {
    nome: "Colangiografia transcutânea - Transparietohepática",
    tuss: "40809064",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — RADIOGRAFIA
  {
    nome: "Radiografia de tórax PA e perfil",
    tuss: "40805026",
    categoria: "imagem",
  },
  {
    nome: "Radiografia de abdome simples",
    tuss: "40808017",
    categoria: "imagem",
  },
  {
    nome: "Radiografia de abdome agudo",
    tuss: "40808025",
    categoria: "imagem",
  },

  // EXAMES DE IMAGEM — MEDICINA NUCLEAR
  {
    nome: "Cintilografia do fígado e baço",
    tuss: "40702022",
    categoria: "imagem",
  },
  {
    nome: "Cintilografia do fígado e vias biliares",
    tuss: "40702030",
    categoria: "imagem",
  },
  {
    nome: "Cintilografia renal dinâmica",
    tuss: "40704017",
    categoria: "imagem",
  },
  {
    nome: "Cintilografia óssea (mapeamento ósseo)",
    tuss: "40706010",
    categoria: "imagem",
  },
  { nome: "PET-CT oncológico", tuss: "40708128", categoria: "imagem" },
  { nome: "Densitometria óssea", tuss: "40808130", categoria: "imagem" },

  // EXAMES DE IMAGEM — FUNÇÃO PULMONAR
  { nome: "Espirometria", tuss: "40105148", categoria: "imagem" },
  {
    nome: "Prova de função pulmonar completa",
    tuss: "40105075",
    categoria: "imagem",
  },
];

// ============================================
// 📦 CONJUNTOS PADRÃO DO SISTEMA
// ============================================

export interface ConjuntoExames {
  id: string;
  nome: string;
  descricao?: string;
  exames: string[]; // nomes dos exames (referência ao catalogoExames)
  tipo: "sistema" | "usuario";
  usuarioId?: string;
  usuarioNome?: string;
}

export const conjuntosPadrao: ConjuntoExames[] = [
  {
    id: "meld-basico",
    nome: "MELD 3.0",
    descricao: "Exames para cálculo do MELD e acompanhamento básico",
    tipo: "sistema",
    exames: [
      "Creatinina sérica",
      "Bilirrubina total e frações séricas",
      "Tempo de protrombina",
      "Sódio sérico",
      "Hemograma completo",
      "Alfa-fetoproteína sérica",
      "Grupo sanguíneo ABO e RH",
      "Albumina sérica",
    ],
  },
  {
    id: "pos-tx-rotina",
    nome: "Pós-Tx Rotina",
    descricao: "Acompanhamento de rotina pós-transplante hepático",
    tipo: "sistema",
    exames: [
      "AST (TGO)",
      "ALT (TGP)",
      "Fosfatase alcalina sérica",
      "Gama GT",
      "Bilirrubina total e frações séricas",
      "Tempo de protrombina",
      "Hemograma completo",
      "Sódio sérico",
      "Potássio sérico",
      "Ureia sérica",
      "Creatinina sérica",
      "Tacrolimo sérico",
    ],
  },
  {
    id: "avaliacao-inicial",
    nome: "Avaliação Inicial",
    descricao: "Investigação completa para primeira consulta hepatológica",
    tipo: "sistema",
    exames: [
      // Bioquímica
      "Bilirrubina total e frações séricas",
      "Fosfatase alcalina sérica",
      "Gama GT",
      "AST (TGO)",
      "ALT (TGP)",
      "Proteínas totais e frações",
      "Colesterol total e frações",
      "Triglicerídeos",
      "Glicemia em jejum",
      "Hemoglobina glicada A1C",
      "Ferritina",
      "Saturação de transferrina",
      "Eletroforese de proteínas séricas",
      "Hemograma completo",
      "Creatinina sérica",
      "Sódio sérico",
      "Tempo de protrombina",
      // Autoanticorpos
      "FAN (fator anti-nuclear)",
      "Anti-LKM-1",
      "Anticorpos anti-músculo liso",
      "Anticorpo anti-mitocôndria",
      // Hepatite A
      "Anti-HAV IgG",
      "Anti-HAV IgM",
      // Hepatite B
      "HBsAg",
      "Anti-HBs",
      "Anti-HBc IgG",
      "HBeAg",
      "Anti-HBe",
      // Hepatite C
      "Anti-HCV",
      // Hepatite D
      "Anti-HDV (hepatite delta)",
      // HIV / HTLV
      "Anti-HIV 1 e 2",
      "HTLV I/II",
      // Outras sorologias
      "Anti-toxoplasmose IgG",
      "Anti-toxoplasmose IgM",
      "Anti-CMV IgG",
      "Anti-CMV IgM",
      "Anti-EBV IgG (VCA)",
      "Anti-EBV IgM (VCA)",
      "Chagas (sorologia)",
      "Estrongiloidíase (anticorpos anti-Strongyloides)",
      // PCR virais (formulários próprios)
      "CMV PCR quantitativo",
      "EBV PCR quantitativo",
      "HBV-DNA (PCR quantitativo)",
      "HCV-RNA (PCR quantitativo)",
      // Prova tuberculínica
      "PPD (tuberculina)",
      "IGRA / Quantiferon-TB (interferon-gama)",
      // Imagem
      "Doppler colorido de órgão ou estrutura isolada (fígado)",
      "Endoscopia digestiva alta",
    ],
  },
];

// ============================================
// 🔍 BUSCA DE EXAME POR NOME
// ============================================
export const buscarExamePorNome = (nome: string): ExameTUSS | undefined => {
  return catalogoExames.find(
    (e) => e.nome.toLowerCase() === nome.toLowerCase()
  );
};

// Busca parcial (para autocomplete)
// Remover acentos para busca
const removerAcentos = (str: string): string => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const buscarExames = (termo: string): ExameTUSS[] => {
  if (!termo || termo.length < 2) return [];
  const termoNorm = removerAcentos(termo.toLowerCase());
  return catalogoExames.filter(
    (e) =>
      removerAcentos(e.nome.toLowerCase()).includes(termoNorm) ||
      e.tuss.includes(termo)
  );
};
